import { TFilterOption } from "@root/common"
import { TType } from "./types"

export const API_BASE_URL = "https://arbitrage-services-dex-fut.com/api"
export const SOCKET_URL = "wss://arbitrage-services-dex-fut.com"

export const typeOptions: Record<TType, TFilterOption<TType>> = {
 long: {option: "long", name: "Лонг"},
 short: {option: "short", name: "Шорт"}
}